
import RelationshipCard from '../../components/Card/RelationshipCard.vue'
import { getCustomTabsList } from './organizationProjectCardCustomTabs.js'

export default {
  name: 'OrganizationProjectCard',
  extends: RelationshipCard,
  data: function () {
    return {
      typeKeyLocal: 'organizationProject', // @Override
      // typeShownLocal: false
    }
  },
  methods: {
    /**
     * RelationshipCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Override
    getRawCustomTabsList: function (config) {
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user) {
      const access = this.getDefaultAccess()

      access.editPrivate = user.fullAccess
      access.viewPrivate = user.fullAccess
      access.viewPublic = true
      access.editPublic = user.hasRole('admin')
      access.editAny = access.editPublic
      return access
    }
  }
}
